angular.module('graph').controller('ph-analytics-statistics', [
    '$scope', 'ph-core', '$timeout', 'ph-date-service',
    function ($scope, $core, $timeout, $date) {
        $scope.$data = {
            trading_performance: undefined,
            trading_interval   : {},
            date_interval      : {}
        };

        $scope.loader = -1;

        $scope.$chart = {
            basicChart      : {
                x: function () {
                    return function (d) {
                        var s = (d['entry'] !== null) ? d['entry'] : 'null';
                        var f = s.charAt(0).toUpperCase();

                        return d['entry'] = f + s.substr(1, s.length - 1);
                    }
                },
                y: function () {
                    return function (d) {
                        return d['trades'];
                    }
                },
                tooltipContent: function () {
                    return function(y, e, graph) {
                        var item = graph.point;

                        var html = '<h3>' + y + ' (' + e + ')</h3>';

                        if (item.profitable !== undefined)
                            html += '<p>Profitable: ' + d3.format(',.2f')(item.profitable * 100) + ' %</p>';
                        if (item.profitable_trades !== undefined)
                            html += '<p>Profitable trades: ' + d3.format(',.2f')(item.profitable_trades / item.trades * 100) + ' %</p>';
                        if (item.avg_profit !== undefined)
                            html += '<p>Avg. Profit: ' + d3.format(',.2f')(item.avg_profit * 100) + ' %</p>';
                        if (item.avg_loss !== undefined)
                            html += '<p>Avg. Loss: ' + d3.format(',.2f')(item.avg_loss * 100) + ' %</p>';

                        return html;
                    }
                },
                data: function ($data) {
                    if ($data === undefined)
                        return;
                    var other = 0, obj = {};

                    if ($data.length > 0) {
                        other = $data[0]['total_trades'];

                        $data.forEach(function (item) {
                            other -= item['trades'];
                        });

                        obj['entry'] = 'Other';
                        obj['trades'] = other;

                        if (other > 0)
                            $data.push(obj);
                    }

                    return $data;
                }
            },
            directionChart  : {
                x: function () {
                    return function (d) {
                        var s = (d['direction'] !== null) ? d['direction'] : 'null';
                        var f = s.charAt(0).toUpperCase();
                        d['direction'] = f + s.substr(1, s.length - 1);

                        return d['direction'];
                    }
                },
                y: function () {
                    return function (d) {
                        return d['profitable'];
                    }
                },
                tooltipContent: function () {
                    return function(y, e, graph) {
                        return '<h3>' + y + ': ' + e + '</h3>';
                    }
                },
                data: function ($data) {
                    if ($data === undefined)
                        return;
                    var other = 0, obj = {}, output = [];

                    $data['direction'] = 'Win';
                    other = $data['trades'] - $data['profitable'];

                    obj['direction'] = 'Loss';
                    obj['profitable'] = other;

                    output.push($data);
                    if (other > 0)
                        output.push(obj);

                    return $data;
                }
            },
            performanceChart: {
                xAxisTickFormat: function () {
                    return function (d) {
                        return $date.$parse(d).format($scope.format[$scope.$filters.aggregation])
                    }
                },
                yAxisTickFormat: function () {
                    return function (d) {
                        return d3.format(',.2f')(d * 100) + '%'
                    }
                },
                valueFormat: function () {
                    return function (d) {
                        return d3.format(',.2f')(d * 100)
                    }
                },
                data: function ($data) {
                    if ($data === undefined)
                        return;
                    var result = {"values": [], "items": $data.length};

                    $data.forEach(function (item) {
                        result.values.push([item['entry'], item['pl']]);
                    });

                    return [result];
                },
                color: function () {
                    return function (d, i) {
                        return d3.rgb((d[1] < 0) ? '#ff0000' : '#2ca02c');
                    }
                }
            },
            cumulativeChart : {
                xAxisTickFormat: function () {
                    return function (d) {
                        return d3.time.format('%Y-%m-%d')(new Date(d))
                    }
                }, yAxisTickFormat: function () {
                    return function (d) {
                        return d3.format(',.2f')(d * 100) + '%'
                    }
                }, data: function ($data) {
                    if ($data === undefined)
                        return;
                    var result = {"values": []}, pl = 0;

                    $data.forEach(function (item) {
                        result.values.push([$date.$convert(item['entry']), pl += item['pl']])
                    });

                    return [result];
                }
            },
            aggregationChart: {
                yAxisTickFormat: function () {
                    return function (d) {
                        return d3.format(',.0d')(d)
                    }
                },
                valueFormat: function () {
                    return function (d) {
                        return d3.format(',.0d')(d)
                    }
                },
                tooltipContent: function () {
                    return function(key, y, e) {
                        var content = $scope.$filters.aggregation.charAt(0).toUpperCase() + $scope.$filters.aggregation.substr(1) + 's: ' + e;
                        return '<p>' + content + '</p>';
                    }
                },
                data: function ($data) {
                    if ($data === undefined)
                        return;
                    var result = {"values": [], "items": $data.length};

                    var values = {
                        '<-4%' : {
                            'value':0,
                            'interval':-4
                        },
                        '-4/-3%': {
                            'value':0,
                            'interval':-3
                        },
                        '-3/-2%': {
                            'value':0,
                            'interval':-2
                        },
                        '-2/-1%': {
                            'value':0,
                            'interval':-1
                        },
                        '-1/0%' : {
                            'value':0,
                            'interval':0
                        },
                        '0-1%'  : {
                            'value':0,
                            'interval':1
                        },
                        '1-2%'  : {
                            'value':0,
                            'interval':2
                        },
                        '2-3%'  : {
                            'value':0,
                            'interval':3
                        },
                        '3-4%'  : {
                            'value':0,
                            'interval':4
                        },
                        '>4%'  : {
                            'value':0,
                            'interval':5
                        }
                    };

                    $data.forEach(function (item) {
                        if (item['pl'] < -4) {
                            ++values['<-4%'].value;
                        } else if (item['pl'] < -3) {
                            ++values['-4/-3%'].value;
                        } else if (item['pl'] < -2) {
                            ++values['-3/-2%'].value;
                        } else if (item['pl'] < -1) {
                            ++values['-2/-1%'].value;
                        } else if (item['pl'] < 0) {
                            ++values['-1/0%'].value;
                        } else if (item['pl'] < 1) {
                            ++values['0-1%'].value;
                        } else if (item['pl'] < 2) {
                            ++values['1-2%'].value;
                        } else if (item['pl'] < 3) {
                            ++values['2-3%'].value;
                        } else if (item['pl'] < 4) {
                            ++values['3-4%'].value;
                        } else {
                            ++values['>4%'].value;
                        }
                    });

                    for (var index in values) {
                        result.values.push([index, values[index].value, values[index].interval]);
                    }

                    return [result];
                },
                color: function () {
                    return function (d, i) {
                        return d3.rgb((d[2]<=0) ? '#ff0000' : '#2ca02c');
                    }
                }
            },
            statisticsTable : {
                data: function ($data) {
                    return ($data !== undefined) ? $data : undefined;
                }
            },
            riskTable       : {
                data: function ($data) {
                    return $data;
                }
            }
        };

        $scope.$di = {
            trading_performance    : 'performanceChart',
            cumulative_performance : 'cumulativeChart',
            aggregation_performance: 'aggregationChart',
            trading_instrument_type: 'basicChart',
            trading_symbol         : 'basicChart',
            trading_strategies     : 'basicChart',
            trading_time_frame     : 'basicChart',
            short_won              : 'directionChart',
            long_won               : 'directionChart',
            trading_statistics     : 'statisticsTable',
            risk_metrics           : 'riskTable'
        };

        $scope.dateSlider = {};

        $scope.space = 'me';

        $scope.$group = null;

        $scope.momentAggregation = {
            year : 'year',
            month: 'month',
            week : 'isoWeek',
            day  : 'day'
        };

        $scope.$collection = {};

        $scope.$groups = {
            month: 'year',
            week : 'month',
            day  : 'week'
        };

        $scope.aggregations = [
            'month',
            'week',
            'day'
        ];

        $scope.format = {
            year : 'YYYY',
            month: 'MMM',
            week : 'WW',
            day  : 'ddd'
        };

        $scope.$filters = {
            empty: true,
            aggregation: 'month'
        };

        $scope.filtrate = function (start, end, go) {
            if (go) {
                var index = $scope.aggregations.indexOf($scope.$filters.aggregation);
                switch (go) {
                    case 'next':
                        ++index;
                        if (index === $scope.aggregations.length)
                            return;
                        $scope.$filters.aggregation = $scope.aggregations[index];
                        $scope.$data.date_interval.start = start;
                        $scope.$data.date_interval.end = end;
                        $scope.find();
                        break;
                    case 'prev':
                        --index;
                        if (index < 0)
                            return;
                        $scope.$filters.aggregation = $scope.aggregations[index];
                        if ($scope.$filters.aggregation === 'month') {
                            $scope.$data.date_interval.start = $scope.$data.trading_interval.start;
                            $scope.$data.date_interval.end = $scope.$data.trading_interval.end;
                        } else {
                            var $aggregation = $scope.momentAggregation[$scope.$groups[$scope.$groups[$scope.$filters.aggregation]]];
                            $scope.$data.date_interval.start = $date.$parse(start).startOf($aggregation).format('YYYY-MM-DD');
                            $scope.$data.date_interval.end = $date.$parse(end).endOf($aggregation).format('YYYY-MM-DD');
                        }
                        $scope.find();
                        break;
                }
                return;
            }

            $scope.$group = $scope.$filters.aggregation;

            var $default_schema = schema(start, $scope.$filters.aggregation);
            var $range = range(start, end, $scope.$groups[$scope.$filters.aggregation]);
            var $collection = {
                schema: $default_schema,
                interval: {
                    start: start,
                    end: end
                },
                default: true
            };
            for (var $group in $range) {
                var $item = $range[$group];
                $item['items'] = 0;
                $item['sum']   = 0;
                var $schema = range($item.start, $item.end, $scope.$filters.aggregation);
                for (var aggregation in $schema) {
                    var date = $schema[aggregation];

                    if ($collection.default === true)
                        if (objDifference($default_schema, $schema).length > 0)
                            $collection.default = false;

                    if ($scope.$data.trading_performance)
                        $scope.$data.trading_performance[0]['values'].forEach(function ($trade) {
                            var item_date = $date.$parse($trade[0]);
                            if (item_date.isBetween(date.start, date.end) ||
                                item_date.format('YYYY-MM-DD') === date.start ||
                                item_date.format('YYYY-MM-DD') === date.end
                            ) {
                                date['data'] = {date: $trade[0], pl: $trade[1]};
                                ++$item['items'];
                                $item['sum'] += $trade[1];
                            }
                        });
                }
                $item['schema'] = $schema;
            }
            $collection['data'] = $range;

            $scope.$collection = $collection;

        };

        function objDifference (obj1, obj2) {
            var arr1 = Object.keys(obj1);
            var arr2 = Object.keys(obj2);
            return _.difference(arr1, arr2);
        }

        function schema(date, aggregation) {
            var $aggregation = $scope.momentAggregation[$scope.$groups[aggregation]],
                $start = $date.$parse(date).startOf($aggregation),
                $end = $date.$parse(date).endOf($aggregation),
                $schema = {};
            while ($end.diff($start, aggregation, true) > 0.0) {
                var format = $scope.format[aggregation];
                $schema[$start.format(format)] = {};
                $start = $start.add(1, aggregation);
            }

            return $schema;
        }

        function range(start, end, aggregation) {
            var $range = {},
                $aggregation = $scope.momentAggregation[aggregation],
                $start = $date.$parse(start).startOf($aggregation),
                $end = $date.$parse(end).endOf($aggregation);

            while ($end.diff($start, aggregation, true) > 0.0) {
                var format = $scope.format[aggregation];
                $range[$start.format(format)] = {
                    start: $start.format('YYYY-MM-DD'),
                    end  : $date.$parse($start.format('YYYY-MM-DD')).endOf($aggregation).format('YYYY-MM-DD')
                };
                $start = $start.add(1, aggregation);
            }

            return $range;
        }

        $scope.$entry = function ($space) {
            if ($space) $scope.space = $space;
        };

        $scope.init = function ($space) {
            if ($space) $scope.space = $space;

            $scope.dateInterval();
        };

        $scope.find = function (check) {
            var $query = $core.$uri.$query.new({
                aggregation_period  : $scope.$filters.aggregation,
                start               : $scope.$data.date_interval.start,
                end                 : $scope.$data.date_interval.end
            }).str();

            $core.get('/xhr/' +
                $scope.space +
                '/analytics?' +
                $query
            ).then(function ($response) {
                if ($response.data.state === 0) {
                    for (var entry in $scope.$di) {
                        if (!$response.data.data[entry])
                            continue;
                        var $di = $scope.$di[entry];
                        $scope.$data[entry] = $scope.$chart[$di].data(
                            $response.data.data[entry]
                        );

                        if (check && $response.data.data[entry].length > 0) {
                            $scope.$filters.empty = false;
                        }
                    }

                    $scope.filtrate(
                        $scope.$data.date_interval.start,
                        $scope.$data.date_interval.end
                    );
                }

                $scope.loader = 0;
            });
        };

        $scope.dateInterval = function () {
            $core.get('/xhr/' +
                $scope.space +
                '/analytics/dates'
            ).then(function ($response) {
                if ($response.data.state === 0) {
                    if ($response.data.data.start === null || $response.data.data.end === null) {
                        $scope.loader = 0;
                        return;
                    }

                    $scope.$data.trading_interval.start = $scope.$data.date_interval.start = $response.data.data.start;
                    $scope.$data.trading_interval.end = $scope.$data.date_interval.end = $response.data.data.end;

                    $scope.find(true);
                }
            });
        };

    }
]);

angular.module('graph').controller('ph-analytics-portfolio', [
    '$scope', 'ph-core',
    function ($scope, $core) {
        $scope.loader = -1;

        $scope.space = 'me';

        $scope.portfolio = [];

        $scope.query = $core.$uri.$query.new({
            page: 0,
            let: 0
        });

        $scope.$entry = function ($space) {
            if ($space) $scope.space = $space;
        };

        $scope.init = function ($space) {
            if ($space) $scope.space = $space;

            $scope.find();
        };

        $scope.find = function (next) {
            var page = $scope.query.get('page');

            $scope.query.set(
                'page', +(++page)
            );

            $core.get('/xhr/' +
                $scope.space +
                '/analytics/trades/opened?' +
                $scope.query.str()
            ).then(function ($response) {
                if ($response.data.state === 0 && $response.data.data.length > 0) {
                    $scope.portfolio = $scope.portfolio.concat(
                        $response.data.data
                    );

                    if (next) next();
                }

                $scope.loader = 0;
            });
        };

    }
]);

angular.module('graph').controller('ph-analytics-history', [
    '$scope', 'ph-core',
    function ($scope, $core) {
        $scope.loader = -1;
        $scope.lock   = false;
        $scope.space  = 'me';

        $scope.history = [];

        $scope.query = $core.$uri.$query.new({
            page: 0,
            let: 0
        });

        $scope.$entry = function ($space) {
            if ($space) $scope.space = $space;
        };

        $scope.init = function ($space) {
            if ($space) $scope.space = $space;

            $scope.find();
        };

        $scope.find = function (next) {
            var page = $scope.query.get('page');

            $scope.query.set(
                'page', +(++page)
            );

            $core.get('/xhr/' +
                $scope.space +
                '/analytics/trades/closed?' +
                $scope.query.str()
            ).then(function ($response) {
                if ($response.data.state === 0 && $response.data.data.length > 0) {
                    $scope.history = $scope.history.concat(
                        $response.data.data
                    );

                    if (next) next();
                }

                $scope.loader = 0;
            });
        };

        $scope.clear = function () {
            if ($scope.lock)
                return;
            $scope.lock = true;
            $core.delete('/xhr/' +
                $scope.space +
                '/analytics/trades/closed'
            ).then(function ($response) {
                if ($response.data.state === 0) {
                    $scope.history = [];
                }

                $scope.lock = false;
            });
        }

    }
]);

angular.module('graph').controller('ph-analytics-preview', [
    '$scope', 'ph-core', 'ph-date-service', 'ph-preview-storage',
    function ($scope, $core, $date, $previewStorage) {
        $scope.space = 'me';

        $scope.preview = [];

        $scope.$chart = {
            preview: {
                x: function () {
                    return function (d) {
                        return d[0]
                    }
                },
                y: function () {
                    return function (d) {
                        return d[1]
                    }
                },
                data: function ($data) {
                    if ($data === undefined)
                        return;
                    var data = $data['data'];
                    var output = {"values": []}, curr_date = $date.$now(), diff = 0, pl = 0;
                    if (data.length > 0)
                        for (var week = 12, pos = 0, i = 0; week > 0; --week, ++pos) {
                        var item = data[i];

                        var $item_date = $date.$new(item['date']);

                        diff = curr_date.diff($item_date, 'week', true);

                        if (Math.round(diff) >= week) {
                            pl = item['pl'];
                            if (data[i + 1] !== undefined) ++i;
                        }

                        output.values.push([pos, pl]);
                    }

                    return {
                        performance: $data['performance'],
                        drawdown   : $data['drawdown'],
                        chart      : [output]
                    };
                }
            }
        };

        $scope.$entry = function ($space) {
            if ($space) $scope.space = $space;
        };

        $scope.init = function ($space) {
            if ($space) $scope.space = $space;

            $scope.find();
        };

        $scope.find = function ($account) {
            var $id = ($account) ? $account.id : $scope.space;
            var $query = $core.$uri.$query.new({
                type: 'preview'
            }).str();

            $previewStorage.get($id, $query, function ($data) {
                if ($data.length === 0)
                    return;
                $scope.preview = $scope.$chart.preview.data(
                    $data
                );
            });
        };
    }
]);

angular.module('graph').controller('ph-analytics-settings', [
    '$scope', '$window', 'ph-core', '$rootScope',
    function ($scope, $window, $core, $root) {
        $scope.space = 'me';
        $scope.lock  = false;

        $scope.accounts = [];

        $scope.settings = [];

        $scope.form  = {
            "model"  : {}
        };

        $scope.accounts = function () {
            $core.get('/xhr/' +
                $scope.space +
                '/analytics/accounts'
            ).then(function ($response) {
                if ($response.data.state === 0) {
                    $scope.accounts = $response.data.data;
                }
            });
        };

        $scope.main = function ($account) {
            if ($scope.lock)
                return;
            $scope.lock = true;
            $core.post('/xhr/' +
                $scope.space +
                '/analytics/account/main/' +
                $account.id
            ).then(function ($response) {
                if ($response.data.state === 0) {
                    for (var index = 0; index < $scope.accounts.length; ++index) {
                        var account = $scope.accounts[index];

                        if (account.main === true)
                            account.main = false;
                    }

                    $account.main = true;
                }

                $scope.lock = false;
            });
        };

        $scope.update = function () {
            $core.post('/xhr/' +
                $scope.space +
                '/analytics/settings',
                {"settings" : $scope.form.model}
            ).then(function ($response) {
                if ($response.data.state === 0) {
                    $window.location.href = '/analytics';
                } else if($response.data.state === 9) {
                    $root.$broadcast('ph-modal-show', 'Invalid data');
                }
            })
        };

        $scope.$entry = function ($space) {
            if ($space) $scope.space = $space;
        };
    }
]);

angular.module('graph').controller('ph-analytics-statistics-tab', [
    '$scope', '$controller', '$rootScope', 'ph-touch-service', 'ph-broadcast',
    function ($scope, $controller, $root, $phtouch, $broadcast) {
        angular.extend(this, $controller('ph-analytics-statistics', {$scope: $scope}));

        var $module = 'ph-analytics-statistics-tab';

        $phtouch.$watch($scope, $module, function () {
            $phtouch.$touch($module, function () {
                $scope.init();
            });
        });
    }
]);

angular.module('graph').controller('ph-analytics-portfolio-tab', [
    '$scope', '$controller', '$rootScope', 'ph-touch-service', 'ph-broadcast',
    function ($scope, $controller, $root, $phtouch, $broadcast) {
        angular.extend(this, $controller('ph-analytics-portfolio', {$scope: $scope}));

        var $module = 'ph-analytics-portfolio-tab';

        $phtouch.$watch($scope, $module, function () {
            $phtouch.$touch($module, function () {
                $scope.init();
            });
        });
    }
]);

angular.module('graph').controller('ph-analytics-history-tab', [
    '$scope', '$controller', '$rootScope', 'ph-touch-service', 'ph-broadcast',
    function ($scope, $controller, $root, $phtouch, $broadcast) {
        angular.extend(this, $controller('ph-analytics-history', {$scope: $scope}));

        var $module = 'ph-analytics-history-tab';

        $phtouch.$watch($scope, $module, function () {
            $phtouch.$touch($module, function () {
                $scope.init();
            });
        });
    }
]);

